import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { FunctionComponent } from 'react';
import { useDialogAnimation } from '../util/Animation';
import { consumeKeyEvents } from '../util/Keyboard';

type Props = {
	open: boolean;
	title: string;
	message: string;
	confirmLabel?: string;
	onConfirm: () => unknown;
	onClose: () => unknown;
};

export const ConfirmDialog: FunctionComponent<Props> = (props) => {
	const { dialogProps } = useDialogAnimation();

	function handleConfirm() {
		props.onClose();
		props.onConfirm();
	}

	return <Dialog open={props.open} onClose={props.onClose} {...dialogProps} {...consumeKeyEvents}>
		<DialogTitle>{props.title}</DialogTitle>
		<DialogContent>
			<DialogContentText>{props.message}</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button onClick={props.onClose}>
				Cancel
			</Button>
			<Button onClick={handleConfirm} color="error" variant="contained">
				{props.confirmLabel ?? 'Confirm'}
			</Button>
		</DialogActions>
	</Dialog>;
};
